/**
 * Created by mirko on 18/04/18.
 */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

import menu from './modules/menu'

export default new Vuex.Store({
    modules: {
        menu
    },
    strict: false
})